import React from 'react';
import PropTypes from 'prop-types';import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import generalImg from "../../../assets/Iconos-app/Notification.png";
import datosImg from "../../../assets/Iconos-app/datos.png";
import mesesImg from "../../../assets/Iconos-app/Calendario.png";
import usuariosImg from "../../../assets/Iconos-app/Clientes.png";
import cursosImg from "../../../assets/Iconos-app/Cursos.png";
import inicioImg from "../../../assets/Iconos-app/Inicio1.png"
import helpImg from "../../../assets/Iconos-app/i14-b.png"
const NavbarVerticalMenuItem = ({ route }) => {
  const selectIcon = (name) => {
    switch (name) {
      case 'Alumnos':
                return  <img src={generalImg} alt="Icon" 
                    style={{
                    width: '1.5em',    
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle' 
                  }}
                />
      case 'Datos':
        return <img src={datosImg} alt="Icon" 
                    style={{
                    width: '1.5em',    
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle' 
                  }}
                />;
      case 'Meses':
        return <img src={mesesImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>
      case 'Usuarios':
        return  <img src={usuariosImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>
      case 'Profesores':
               return  <img src={usuariosImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>
              case 'Cursos':
               return  <img src={cursosImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>
        case 'Inicio':
               return   <img src={inicioImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>
              case 'Help':
               return   <img src={helpImg} alt='icon'
                  style={{
                    width: '1.5em',
                    height: '1.5em',   
                    objectFit: 'contain', 
                    verticalAlign: 'middle'

                  }}
          >
        </img>  
      default:
        break
      }

  }
  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className="nav-link-icon">
        {/*<FontAwesomeIcon icon={route.icon} />*/}
        {selectIcon(route.name)}         </span>
      )}
      <span className="nav-link-text ps-1">{route.name}</span>
      {route.badge && (
        <SoftBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SoftBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
